import { SBoxInner } from "../../../style/contents/backup/backup";

interface ModalProps {
  closedHandler: () => void;
}

const AlertModal = ({ closedHandler }: ModalProps) => {
  return (
    <SBoxInner className="alert">
      <div className="modal-header">
        <p>알림</p>
        <button onClick={closedHandler} className="closed-modal-btn">
          <img src="/assets/Close_Icons_UIA.svg" alt="" />
        </button>
      </div>
      <div className="modal-body">
        <p>{`아이디, 비밀번호 또는 사용자/관리자 \n선택이 올바른지 확인해주세요.`}</p>
      </div>
    </SBoxInner>
  );
};

export default AlertModal;
